import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { injectIntl, defineMessages } from 'react-intl';
import { Field } from 'formik';
import { Fieldset } from 'primereact/fieldset';
import _ from 'lodash';
import { withAccount } from '../../../components/AccountContext';
import { ACCOUNT_QUERY } from './queries';
import { Loading } from '../../../components/Loading';
import { DropdownWithValidation, LegacyInputTextComponent } from '../../../components/prime-formik';
import hashCode from '../../../utils/StringUtil';


const ariMessages = defineMessages({
  globalFieldsetLegend: {
    id: 'ari.respondent.edit.fieldset.legend.global',
    defaultMessage: 'Global Additional Respondent Information (ARI)',
  },
  localFieldSetLegend: {
    id: 'ari.respondent.edit.fieldset.legend.local',
    defaultMessage: 'Local Additional Respondent Information (ARI)',
  },
  noInformationRequested: {
    id: 'ari.respondent.edit.no.information.requested',
    defaultMessage: 'No additional information requested.',
  },
  noAnswerLabel: {
    id: 'ari.respondent.edit.dialog.noAnswer',
    defaultMessage: 'No answer',
  },
});

const NewRespondentAriFields = ({ currentAccount, intl: { formatMessage } }) => {
  const { data, refetch } = useQuery(ACCOUNT_QUERY, { variables: { accountId: currentAccount } });

  const [accountData, setAccountData] = useState(null);

  useEffect(() => {
    refetch();
    if (data && data.account) {
      setAccountData(data);
    }
  }, [data, refetch]);

  return !accountData ? <Loading /> : (
    <div className="p-grid">
      <div className="p-col-6">
        <Fieldset legend={formatMessage(ariMessages.globalFieldsetLegend)}>
          {
            data.account.globalAriFields.length === 0
              ? (
                <div>
                  {formatMessage(ariMessages.noInformationRequested)}
                </div>
              )
              : (
                _.sortBy(data.account.globalAriFields, f => f.rank)
                  .map((field, index) => {
                    const dropdownOptions = field.answers.map(answer => ({
                      key: answer,
                      label: answer,
                      value: answer,
                    }));

                    return (
                      <div className="form-group" key={field.question} style={{ marginBottom: '5px' }}>
                        <label
                          className="field-label"
                          htmlFor={`global${index + 1}`}
                          style={{ fontStyle: 'italic' }}
                        >
                          {`${field.question}${field.mandatory ? '*' : ''}`}
                        </label>
                        {
                        field.dataType === 'TEXT' && (
                          <Field
                            id={`global${index + 1}`}
                            name={`global_${field.id}_${hashCode(field.question)}`}
                            component={LegacyInputTextComponent}
                          />
                        )
                      }
                        {
                        field.dataType === 'NUMBER' && (
                          <Field
                            id={`global${index + 1}`}
                            name={`global_${field.id}_${hashCode(field.question)}`}
                            component={LegacyInputTextComponent}
                          />
                        )
                      }
                        {
                        field.dataType === 'DROPDOWN' && (
                          <Field
                            id={`global${index + 1}`}
                            name={`global_${field.id}_${hashCode(field.question)}`}
                            component={DropdownWithValidation}
                            options={dropdownOptions}
                            placeholder={formatMessage(ariMessages.noAnswerLabel)}
                          />
                        )
                      }
                      </div>
                    );
                  }))
          }
        </Fieldset>
      </div>

      <div className="p-col-6">
        <Fieldset legend={formatMessage(ariMessages.localFieldSetLegend)}>
          {
            data.account.localAriFields.length === 0
              ? (
                <div>
                  {formatMessage(ariMessages.noInformationRequested)}
                </div>
              )
              : (
                _.sortBy(data.account.localAriFields, f => f.rank)
                  .map((field, index) => {
                    const dropdownOptions = field.answers.map(answer => ({
                      key: answer,
                      label: answer,
                      value: answer,
                    }));

                    return (
                      <div className="form-group" key={field.question} style={{ marginBottom: '5px' }}>
                        <label
                          className="field-label"
                          htmlFor={`local${index + 1}`}
                          style={{ fontStyle: 'italic' }}
                        >
                          {`${field.question}${field.mandatory ? '*' : ''}`}
                        </label>
                        {
                      field.dataType === 'TEXT' && (
                        <Field
                          id={`local${index + 1}`}
                          name={`local_${field.id}_${hashCode(field.question)}`}
                          component={LegacyInputTextComponent}
                        />
                      )
                    }
                        {
                      field.dataType === 'NUMBER' && (
                        <Field
                          id={`local${index + 1}`}
                          name={`local_${field.id}_${hashCode(field.question)}`}
                          component={LegacyInputTextComponent}
                        />
                      )
                    }
                        {
                      field.dataType === 'DROPDOWN' && (
                        <Field
                          id={`local${index + 1}`}
                          name={`local_${field.id}_${hashCode(field.question)}`}
                          component={DropdownWithValidation}
                          options={dropdownOptions}
                          placeholder={formatMessage(ariMessages.noAnswerLabel)}
                        />
                      )
                    }
                      </div>
                    );
                  }))
          }
        </Fieldset>
      </div>
    </div>
  );
};

NewRespondentAriFields.propTypes = {
  currentAccount: PropTypes.string.isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default injectIntl(withAccount(NewRespondentAriFields));
